// Pain Signal Funnel - Question Definitions

// Question order for pain signal funnel
export const DEFAULT_QUESTION_ORDER = [
  'painSignals',
  'worryFrequency',
  'barrier',
  'debtAmount',
  'name',
  'email',
  'address',
  'dob',
  'phone'
]

// Question definitions
export const questionDefinitions = {
  painSignals: {
    id: 'painSignals',
    headline: 'In the last 30 days, have you experienced any of the following?',
    subheadline: 'Select all that apply',
    showHeadlines: true,
    showProgress: false,
    type: 'multiSelect',
    options: [
      { text: 'Missed a payment or paid late', value: 'missed_payment' },
      { text: 'Paid only the minimum on one or more accounts', value: 'minimums_only' },
      { text: 'Received a call or letter from a collector', value: 'collection_contact' },
      { text: 'Borrowed money or used one card to pay another', value: 'robbing_peter' }
    ],
    chat: "<p>Hi there! I'm Catherine. I'm here to understand your situation and find the best debt relief options for you.</p>",
    defaultValue: []
  },

  worryFrequency: {
    id: 'worryFrequency',
    headline: 'How often do you think about your debt?',
    showHeadlines: false,
    showProgress: true,
    type: 'buttons',
    options: [
      { text: "Constantly - it's always on my mind", value: 'constantly' },
      { text: 'Daily - it comes up every day', value: 'daily' },
      { text: 'Sometimes - a few times a week', value: 'sometimes' },
      { text: 'Rarely - only when bills come', value: 'rarely' }
    ],
    chat: '<p>Understanding how debt affects you helps us find the right solution.</p>',
    defaultValue: null
  },

  barrier: {
    id: 'barrier',
    headline: "What's the main thing keeping you from paying off your debt?",
    showHeadlines: false,
    showProgress: true,
    type: 'buttons',
    options: [
      { text: "I've tried things that didn't work", value: 'tried_failed' },
      { text: "I don't know where to start", value: 'dont_know_start' },
      { text: 'I have too many accounts to manage', value: 'too_many_accounts' },
      { text: 'Interest rates are too high', value: 'interest_too_high' },
      { text: "My income doesn't cover enough", value: 'income_too_low' }
    ],
    chat: '<p>This helps us understand which debt relief program might work best for you.</p>',
    defaultValue: null
  },

  debtAmount: {
    id: 'debtAmount',
    headline: 'How much credit card debt do you have?',
    showHeadlines: false,
    showProgress: true,
    type: 'buttons',
    options: [
      { text: 'More than $20,000', value: 'over_20k' },
      { text: '$15,000 - $20,000', value: '15k_20k' },
      { text: '$10,000 - $15,000', value: '10k_15k' },
      { text: 'Less than $10,000', value: 'under_10k' }
    ],
    chat: '<p>Credit card debt is often the best candidate for debt relief programs.</p>',
    defaultValue: null
  },

  name: {
    id: 'name',
    showHeadlines: false,
    showProgress: true,
    type: 'name',
    chat: '',
    defaultFirst: '',
    defaultLast: ''
  },

  email: {
    id: 'email',
    showHeadlines: false,
    showProgress: true,
    type: 'email',
    chat: "<p>We'll only send you valuable information related to your needs.</p>",
    defaultValue: '',
    defaultSendtoAC: true
  },

  address: {
    id: 'address',
    showHeadlines: false,
    showProgress: true,
    type: 'address',
    chat: '<p>Additional options may apply based on where you live.</p>',
    defaultAddress: '',
    defaultZip: '',
    defaultCity: '',
    defaultState: ''
  },

  dob: {
    id: 'dob',
    showHeadlines: false,
    showProgress: true,
    type: 'dob',
    chat: '<p>This will help us find specific solutions for you.</p>',
    defaultDay: '',
    defaultMonth: '',
    defaultYear: ''
  },

  phone: {
    id: 'phone',
    showHeadlines: false,
    showProgress: true,
    type: 'contact',
    chat: '<p style="font-weight: 600; margin-top: 9px;">What happens next?</p><ul><li>Your information will be encrypted using 256 SSL technology.</li><li>You\'ll be matched with a debt relief specialist who will call you to discuss the best options for your situation.</li></ul>',
    defaultValue: ''
  }
}

// Get question config (simplified - no EMP mode in pain signal funnel)
export function getQuestionConfig(questionId, options = {}) {
  const base = questionDefinitions[questionId]
  if (!base) return null

  // Handle name with dynamic chat message
  if (questionId === 'name' && options.nameChatMessage) {
    return {
      ...base,
      chat: options.nameChatMessage
    }
  }

  return base
}

// Get all question IDs
export function getAllQuestionIds() {
  return Object.keys(questionDefinitions)
}
